import RestApiModel from "@/api/Model/RestApiModel";
import api from '../index';

class FDO extends RestApiModel {
  static list(facilityId) {
    return super.list({
      endpoint: `/facilities/${facilityId}/fdos`
    })
  }

  static getResourceEndpoint() {
    return `/facility-fdos`;
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, {isEnabled});
  }
}

export default FDO;
